import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import globalStore from '@/store/global';
import genFileTypesStore from './store';
import fieldCategoryStore from '@/components/field-category/store';
import { HelpOther } from '@/common/helper';
import client from '@/store/client';
import homeSimpleAgentsStore from '../simple-agents/store';
import { Tooltip } from 'antd';
import userStore from '@/store/user';

const GenFileTypes = observer((props) => {
  const list = globalStore.cloudConfig.assistantSpecifyGenFileType;
  const store = genFileTypesStore;

  if(!list?.length){
    return null;
  }

  return (
    <div className='mt-22px flex'>
      {
        list.map(item => {
          const disabled = item.status == 2;

          return (
            <Tooltip
              key={item.title}
              overlayClassName="field-category-tooltip" 
              placement="top"
              getPopupContainer={node => node}
              arrow={false} 
              align={{offset: [0, -6]}}
              title={
                disabled ? <div className="text-12px text-black text-opacity-70 leading-17px text-left">敬请期待</div> : null
              }
              >
              <div 
                key={item.title}
                className={`cursor-pointer border-1px border-black border-opacity-16 w-125px h-92px rounded-10px flex flex-col items-center justify-center mr-10px last-of-type:mr-0 bg-white hover:bg-[#f7f7f7] ${store.hasChecked(item.value) ? 'rb-current' : ''}`}
                onClick={
                  () => {
                    if(disabled){
                      return;
                    }

                    if(!client.isLLQ){
                      HelpOther.toast('去PC端体验完整功能', 'warning');
                      return;
                    }

                    userStore.doWhenLogin(() => {
                      store.setChecked(item.value);
                      globalStore.robotAiso(true);
                      homeSimpleAgentsStore.reset();
                      fieldCategoryStore.checkCategory(-1);
                    });
                  }
                }>
                {
                  item.icon
                  ? <img src={item.icon} className='size-48px' />
                  : null
                }
                {item.title}
              </div>
            </Tooltip>
          )
        })
      }
    </div>
  )
});
export default GenFileTypes;